import { SiloOutlineIcon } from './SiloOutlineIcon';

/**
 * author: Benjamin Watson
 * id 73A40E8E-7F62-454C-BFD9-A10796BA4A0A
 * name silo-outline
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/silo-outline.svg
 * tags
 * - Agriculture 
 */
export const FarmOutlineIcon = SiloOutlineIcon;
export default FarmOutlineIcon